// extracted by mini-css-extract-plugin
export default {"root":"style_root__2KXeR","title":"style_title__1zgfL","tips":"style_tips__33EGd"};